// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AB47","colBig":"styles_colBig__3efco","colSmall":"styles_colSmall__2PtjA","shopifyNameWrapper":"styles_shopifyNameWrapper__3OvWq"};